export default __webpack_public_path__ + "static/media/devices_wdc_lite.96180deb.svg";